import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { GroupOfResearches } from "../types"
import { API_URL } from "../constants"

export function useGroupsOfResearchesList(params: Record<string, string> = {}) {
  return useList<GroupOfResearches>(`${API_URL}/admin/group-of-researches`, {
    query: params,
  })
}

export function useGroupOfResearch(id: number | undefined) {
  return useDetail<GroupOfResearches>(`${API_URL}/admin/group-of-researches`, id?.toString())
}

export function useCreateGroupOfResearch() {
  return useCreate<GroupOfResearches>(`${API_URL}/admin/group-of-researches`, {
    encode: "formdata",
  })
}

export function useUpdateGroupOfResearch() {
  return useUpdate<GroupOfResearches>(`${API_URL}/admin/group-of-researches`, {
    encode: "formdata",
  })
}

export function useDeleteGroupOfResearch() {
  return useDelete(`${API_URL}/admin/group-of-researches`)
}

export function usePartialUpdateroupOfResearch() {
  return usePartialUpdate<GroupOfResearches>(`${API_URL}/admin/group-of-researches`, {
    encode: "formdata",
  })
}

export function useDeleteMultiGroupOfResearch() {
  return useAction(`${API_URL}/admin/group-of-researches/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}
